import { PUBLISH_OR_UNPUBLISH_CONTENT, RESET_PUBLISH_STORE } from "../types";

const initialState = {
  loading: false,
  message: null,
  data: {},
};

export const publishReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESET_PUBLISH_STORE:
      return { ...initialState };

    case `${PUBLISH_OR_UNPUBLISH_CONTENT}_PENDING`:
      return { ...state, message: null, loading: true };

    case `${PUBLISH_OR_UNPUBLISH_CONTENT}_FULFILLED`:
      return {
        ...state,
        loading: false,
        data: action.payload.data ? action.payload.data.results : {},
        message: action.payload.message || action.payload.data.message,
      };

    case `${PUBLISH_OR_UNPUBLISH_CONTENT}_REJECTED`:
      return {
        ...state,
        loading: false,
        data: null,
        message: `${action.payload.data}`,
      };

    default:
      return state;
  }
};
